import { Grid, Paper, Typography, Select, MenuItem, FormControl, InputLabel, Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { RadialBarChart, RadialBar, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import Input from "../../../components/common/input/Input";
import axiosInstance from "../../../utils/axios/axiosInstance";
import API from "../../../config/apiconfig";
import { useDispatch, useSelector } from "react-redux";
import { userApiLoader } from "../../../action/loaderActions";
import { toast } from "react-toastify";

import { userLoginSuccess } from "../../../action/userActions";


const dailyWaterData = [
  {
    name: "Water Intake",
    value: 2.8,
    maxValue: 5,
  },
];

const weeklyWaterData = [
  {
    name: "Water Intake",
    value: 18.4,
    maxValue: 35,
  },
];

const monthlyWaterData = [
  {
    name: "Water Intake",
    value: 120,
    maxValue: 150,
  },
];

const dailyStepsData = [
  { hour: "6 AM", steps: 1500 },
  { hour: "12 PM", steps: 2000 },
  { hour: "6 PM", steps: 3000 },
  { hour: "9 PM", steps: 2500 },
];

const weeklyStepsData = [
  { day: "Mon", steps: 4500 },
  { day: "Tue", steps: 5500 },
  { day: "Wed", steps: 6200 },
  { day: "Thu", steps: 7000 },
  { day: "Fri", steps: 8000 },
  { day: "Sat", steps: 10000 },
  { day: "Sun", steps: 12000 },
];

const monthlyStepsData = [
  { month: "Jan", steps: 120000 },
  { month: "Feb", steps: 115000 },
  { month: "Mar", steps: 130000 },
  { month: "Apr", steps: 140000 },
  { month: "May", steps: 135000 },
];

const Goalsettingtab = () => {
  const dispatch = useDispatch();
  const { UserId: reduxUserId } = useSelector((state) => state.user);
   const [userId, setUserId] = useState(reduxUserId || null);

useEffect(() => {
  if (!reduxUserId) {
    dispatch(userApiLoader({ isApiLoader: true }));
    axiosInstance.get(`${API.USER_MANAGEMENT_API_BASE_URL}${API.PROFILE_DETAILS}`)
      .then((res) => {
        const { user_id } = res?.data?.data || {};
        if (user_id) {
          setUserId(user_id);
          dispatch(userLoginSuccess({ UserId: user_id }));
        }
        dispatch(userApiLoader({ isApiLoader: false }));
      })
      .catch((err) => {
        console.error("Failed to fetch user profile:", err);
        dispatch(userApiLoader({ isApiLoader: false }));
      });
  }
}, [reduxUserId]);



 // const {UserId} = useSelector(state => state.user);
  const [period, setPeriod] = useState("daily");
  const [stepsData, setStepsData] = useState([]);
  const [waterData, setWaterData] = useState([]);
  const [goalName, setGoalName] = useState("");
  const [metric, setMetric] = useState("");
  const [target, setTarget] = useState("");
  const [unit, setUnit] = useState("");
  const [frequency, setFrequency] = useState("");
  const [goalsData, setGoalsData] = useState({
    daily: [],
    weekly: [],
    monthly: [],
  });
  


  const handlePeriodChange = (event) => {
    const selectedPeriod = event.target.value;
    setPeriod(selectedPeriod);

    switch (selectedPeriod) {
      case "daily":
        setStepsData(dailyStepsData);
        setWaterData(dailyWaterData);
        break;
      case "weekly":
        setStepsData(weeklyStepsData);
        setWaterData(weeklyWaterData);
        break;
      case "monthly":
        setStepsData(monthlyStepsData);
        setWaterData(monthlyWaterData);
        break;
      default:
        setStepsData(dailyStepsData);
        setWaterData(dailyWaterData);
    }
  };

  const getGoalsList = () => {
    dispatch(userApiLoader({isApiLoader: true}));
    axiosInstance.get(`${API.USER_MANAGEMENT_API_BASE_URL}${API.HEALTH_TRACKER}${API.GOALS}`)
      .then((res) => {
        dispatch(userApiLoader({isApiLoader: false}));
        const data = res.data.data;
        setGoalsData({
          daily: data.daily_goals || [],
          weekly: data.weekly_goals || [],
          monthly: data.monthly_goals || [],
        });
        toast.success(res?.data?.message, { autoClose: 6000 });
      })
      .catch((err) => {
        console.error("Failed to fetch goals:", err);
        dispatch(userApiLoader({isApiLoader: false}));
        toast.error(err?.data?.message, { autoClose: 6000 });
      });
  };  

  useEffect(() => {
    getGoalsList();
  },[])

  const handleCreateGoal = () => {
  dispatch(userApiLoader({ isApiLoader: true }));

  // Static mapping for demonstration
  const goalIdMap = {
    "water intake": 5,
    "steps": 6,
    // Add more mappings as needed
  };

  const payload = {
   // goal_id: goalIdMap[goalName.toLowerCase()] || 5, // fallback to 5

   user_id: userId,
    metric: goalName,
    target,
    unit,
    frequency: Number(frequency),
  };

  axiosInstance.post(
    `${process.env.REACT_APP_HEALTH_TRACKER_API_BASE_URL}v1/health/goals`,
    payload
  )
    .then((res) => {
      getGoalsList();
      dispatch(userApiLoader({ isApiLoader: false }));
      toast.success(res?.data?.message || "Goal set successfully", { autoClose: 6000 });
    })
    .catch((err) => {
      console.error("Failed to set goal:", err);
      dispatch(userApiLoader({ isApiLoader: false }));
      toast.error(err?.response?.data?.message || "Failed to set goal", { autoClose: 6000 });
    });
};

  
  useEffect(() => {
    const currentGoals = goalsData[period] || [];
    const waterGoal = currentGoals.find(goal => goal.metric.toLowerCase() === "water intake");
    const stepsGoal = currentGoals.find(goal => goal.metric.toLowerCase() === "steps");
  
    if (waterGoal) {
      setWaterData([
        {
          name: "Water Intake",
          value: waterGoal.achieved || 5,
          maxValue: parseFloat(waterGoal.goal),
        }
      ]);
    } else {
      setWaterData([]);
    }
  
    if (stepsGoal) {
      setStepsData([
        {
          [period === "daily" ? "hour" : period === "weekly" ? "day" : "month"]: "Goal",
          steps: stepsGoal.achieved || 0,
          maxSteps: parseFloat(stepsGoal.goal),
        }
      ]);
    } else {
      setStepsData([]);
    }
  }, [goalsData, period]);

  console.log(waterData);
  
  
  return (
    <Grid container spacing={2} style={{ padding: "0px !important" }} className="max-h-[calc(100vh-210px)] overflow-y-auto">
      <Grid item xs={12} lg={4}>
        <Paper elevation={3} className="p-5 relative">
            <Typography variant="subtitle1" color="textPrimary" className="!font-semibold">
                Create Goal
            </Typography>
            <div className="flex flex-col mt-5 gap-2">
                    <Input
                      label="Goal name"
                      fullWidth={true}
                      placeholder="Enter goal name"
                      value={goalName}
                      onChange={(e) => setGoalName(e.target.value)}
                    />
                    <Input
                      label="Target"
                      fullWidth={true}
                      placeholder="Enter target"
                      value={target}
                      onChange={(e) => setTarget(e.target.value)}
                    />

                 <div className="flex flex-col gap-4">
  <FormControl fullWidth size="small">
    <InputLabel shrink>Unit</InputLabel>
    <Select
      value={unit}
      onChange={(e) => setUnit(e.target.value)}
      displayEmpty
      sx={{ height: 40, mt: .9 }}
    >
      <MenuItem value="" disabled>Select unit</MenuItem>
      <MenuItem value="Steps">Steps</MenuItem>
      <MenuItem value="hrs">hrs</MenuItem>
      <MenuItem value="KCal">KCal</MenuItem>
      <MenuItem value="BPM">BPM</MenuItem>
      <MenuItem value="Ltr">Ltr</MenuItem>
    </Select>
  </FormControl>

  <FormControl fullWidth size="small">
    <InputLabel shrink>Frequency</InputLabel>
    <Select
      value={frequency}
      onChange={(e) => setFrequency(e.target.value)}
      displayEmpty
      sx={{ height: 40, mt: .9 }}
    >
      <MenuItem value="" disabled>Select frequency</MenuItem>
      <MenuItem value={1}>Daily</MenuItem>
      <MenuItem value={2}>Weekly</MenuItem>
      <MenuItem value={3}>Monthly</MenuItem>
    </Select>
  </FormControl>
</div>



                <div className="mt-10">
                    <Button variant="contained" color="primary" onClick={handleCreateGoal}>Create</Button>
                </div>
            </div>
        </Paper>
      </Grid>

      <Grid item xs={12} lg={8} className="h-full">
  <Paper elevation={3} className="p-5 relative h-full">
    <Typography variant="subtitle1" color="textPrimary" className="!font-semibold">
      Goals List
    </Typography>

    <Box display="flex" justifyContent="flex-end" mb={3}>
      <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>
        <InputLabel>Period</InputLabel>
        <Select value={period} onChange={handlePeriodChange} label="Period">
          <MenuItem value="daily">Daily</MenuItem>
          <MenuItem value="weekly">Weekly</MenuItem>
          <MenuItem value="monthly">Monthly</MenuItem>
        </Select>
      </FormControl>
    </Box>

    {goalsData[period]?.length > 0 ? (
      <Grid container spacing={2}>
        {goalsData[period].map((goal, idx) => {
          const progress = goal.goal > 0 ? (goal.achieved / goal.goal) * 100 : 0;
          return (
            <Grid item xs={12} key={goal.id || idx}>
              <Typography variant="body2" className="!font-semibold mb-1">
                {goal.metric} ({goal.achieved} / {goal.goal} {goal.unit})
              </Typography>
              <Box width="100%" bgcolor="#eee" borderRadius={5}>
                <Box
                  width={`${Math.min(progress, 100)}%`}
                  bgcolor="#7042c9"
                  color="white"
                  p={0.5}
                  borderRadius={5}
                  textAlign="center"
                  fontSize="0.75rem"
                >
                  {`${Math.round(progress)}%`}
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    ) : (
      <Typography variant="body2">No goals set for this period.</Typography>
    )}
  </Paper>
</Grid>



    </Grid>
  );
};

export default Goalsettingtab;
